module.exports = __webpack_public_path__ + "static/media/WSW_logo.c4ff48c2.png";